import { Component, inject } from '@angular/core';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'mbs-wizards-legacy-property-tooltip',
  template: `<span
    class="fa fa-info-circle ml-2 cursor-help text-info"
    tooltipClass="tooltip-lg"
    [container]="'body'"
    [ngbTooltip]="'wizards:legacy.legacyPropertyTooltip' | i18next"></span>`,
  imports: [NgbTooltipModule, I18NextPipe]
})
export class LegacyPropertyTooltipComponent {
  i18nPipe = inject(I18NextPipe);
}
